import { render, staticRenderFns } from "./gonggaogongshi.vue?vue&type=template&id=552067db&scoped=true"
import script from "./gonggaogongshi.vue?vue&type=script&lang=js"
export * from "./gonggaogongshi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552067db",
  null
  
)

export default component.exports